import { render, staticRenderFns } from "./ReferralDetails.vue?vue&type=template&id=9c808744"
import script from "./ReferralDetails.vue?vue&type=script&lang=js"
export * from "./ReferralDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports